import { AnyAction } from "redux";
import MapZoom from "../../../constants/MapZoom";
import { IStoreState } from "./types";
import ActionTypes from '../../../constants/ActionTypes';
import MapFilters from "../../../constants/MapFilters";

const initialState: IStoreState = {
  visibility: false,
  stores: [],
  cities: [],
  visibilityFilter: MapFilters.all,
  fiveClosestStatus: false,
  userGeolocation: {
    lat: null,
    lon: null,
  },
  center: {
    lat: 44.304340,
    lng: 20.565689,
  },
  zoom: MapZoom.geoLocationZoom,
  activeStoreId: 0,
};

const storesMapReducer = (
  state = initialState,
  action: AnyAction
): IStoreState => {
  switch (action.type) {
  case ActionTypes.STORES_MAP.SET_VISIBILITY:
    return {
      ...state,
      visibility: action.payload
    };
  case ActionTypes.STORES_MAP.SET_STORES:
    return {
      ...state,
      stores: action.payload
    };
  case ActionTypes.STORES_MAP.SET_MAP_CENTER:
    return {
      ...state,
      center: action.payload.center,
      zoom: action.payload.zoom
    };
  case ActionTypes.STORES_MAP.SET_ACTIVE_STORE_ID:
    return {
      ...state,
      activeStoreId: action.payload
    };
  case ActionTypes.STORES_MAP.SET_STORE_FILTER:
    return {
      ...state,
      visibilityFilter: action.payload
    };
  case ActionTypes.STORES_MAP.SET_CLOSEST_STORES_STATUS:
    return {
      ...state,
      fiveClosestStatus: !state.fiveClosestStatus
    };
  case ActionTypes.STORES_MAP.SET_CITIES:
    return {
      ...state,
      cities: action.payload
    };
  case ActionTypes.STORES_MAP.SET_USER_GEO_LOCATION:
    return {
      ...state,
      userGeolocation: { lat: action.payload.lat, lon: action.payload.lon }
    };
  }

  return state;
};

export default storesMapReducer;
